import { render, staticRenderFns } from "./CopySettingsDialog.vue?vue&type=template&id=4e173750"
import script from "./CopySettingsDialog.vue?vue&type=script&lang=js"
export * from "./CopySettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports